// AskIsaac Brand Identity - Centralized Logo Constants
// Updated: January 2026 - New [i] Brand Identity

// Primary Logo - Horizontal with text "{i} AskIsaac"
export const ASKISAAC_LOGO = "/logos/askisaac-b-monogram.svg";

// Alias for common usage
export const LOGO_URL = ASKISAAC_LOGO;

// Dark Mode Logo (same as primary - works on both dark and light backgrounds)
export const ASKISAAC_LOGO_DARK = "/logos/askisaac-b-monogram.svg";

// Light Mode Logo (for light backgrounds - keeping same for consistency)
export const ASKISAAC_LOGO_LIGHT = "/logos/askisaac-b-monogram.svg";

// Favicon/Icon - Sterile Mate branded (served from /public)
export const ASKISAAC_FAVICON = "/favicon-512.png";

// Legacy aliases for backward compatibility
export const STERILE_MATE_LOGO = ASKISAAC_LOGO;
export const STERILE_MATE_LOGO_COLOR = ASKISAAC_LOGO;
export const STERILE_MATE_LOGO_WHITE = ASKISAAC_LOGO_DARK;

// Brand Colors
export const BRAND_COLORS = {
  primary: '#3b82f6',      // Healthcare Blue
  primaryDark: '#2563eb',  // Darker Blue
  accent: '#0ea5e9',       // Cyan accent
};
